import { Box, Button, IcArrowRight, Text } from '@fozito/common-ui';
import { Popover } from 'antd';
import { get } from 'lodash';
import useConfirmTipTicket from 'modules/POS/PaymentDetails/ConfirmTipTicket';
import { useTicketWrapper } from 'modules/POS/Receipts/context';
import cashierService from 'modules/POS/services';
import cashierApis from 'modules/POS/services/apis';
import { IApiCashierPaymentBody } from 'modules/POS/services/types/payment';
import shopService from 'modules/shop/services';
import { useMemo, useState } from 'react';
import { IResponseData } from 'services/response';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import toast from 'utils/toast';
import { setPageLoading } from 'widgets/PageLoading';
import { PAYMENT_TYPE } from '../../cashier.constants';
import { cashierCtrl } from '../../cashier.controller';
import { IUICashierFormValues } from '../../cashier.interface';
import CashierActionButton, { ActionType } from '../../components/CashierActionButton';
import ModalCheckPayment, { useModalCheckPaymentRef } from './CheckPayment';
import ModalQRPayment, { ICashierQRPaymentMethod, useModalQRPaymentRef } from './QRPayment';
import { useSocketContext } from '../../hooks/useSocket';
type Props = {
  cashIncentive?: IUICashierFormValues['cashIncentive'];
  cashIncentiveAmount?: IUICashierFormValues['cashIncentiveAmount'],
  enable?: IUICashierFormValues['cashIncentiveDiscount'],
};
const CashierEPays = ({ cashIncentive, cashIncentiveAmount, enable }: Props) => {
  const [completedTicketModalRef, completedTicketModalContext] = useConfirmTipTicket();
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const QRPaymentRef = useModalQRPaymentRef();
  const checkPaymentRef = useModalCheckPaymentRef();
  const payments = shopService.selectors.paymentOthers();
  const ticketContext = useTicketWrapper();
  const socketContext = useSocketContext();

  const onCancelPayment = () => undefined;

  const onPayment: ICashierQRPaymentMethod = async (billId, paymentItem) => {
    setPageLoading(true);
    const body: IApiCashierPaymentBody = {
      billId, payments: [paymentItem],
    };
    try {
      const res: IResponseData<any> = await cashierApis.paymentTicket(body);
      if (res.data.data) {
        toast.success('Success');
        dispatch(cashierService.actions.async.lstBillOnHold.fetch());
        socketContext.alertPaymentSuccess(billId);
        const callback = () => {
          cashierCtrl.generateNewTicketAfterPayment();
        };
        if (!completedTicketModalRef.current) {
          callback();
          ticketContext.completedTicket(billId, true);
        } else {
          completedTicketModalRef.current.open(billId, callback);
        }
        return true;
      }
      throw res.data.data;
    } catch (error) {
      const msg = get(error, ['response', 'data', 'message'], 'Fail');
      toast.error(msg);
      return false;
    } finally {
      setPageLoading(false);
    }
  };


  const onQR = async (type: string) => {
    setOpen(false);
    cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
      if (billId) QRPaymentRef.current?.open(billId, type);
    });
  };

  const onCheck = async () => {
    setOpen(false);
    cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
      if (billId) checkPaymentRef.current?.open(billId);
    });
  };

  const content = useMemo(() => <BoxContent display='flex' flexDirection='column' gap={'8px'} width={'200px'}>
    {payments.map(o => o.methodType === PAYMENT_TYPE.CHECK ? (
      <Button key={o.methodType} onClick={onCheck} type_tertiary>
        <Text>CHECK</Text>
        <IcArrowRight />
      </Button>
    ) : (
      <Button key={o.methodType} onClick={() => onQR(o.methodType)} type_tertiary>
        <Text>{o.methodName}</Text>
        <IcArrowRight />
      </Button>
    ))}
  </BoxContent>, [payments]);
  return (
    <>
      <Popover
        trigger={['click']} content={content} open={open} onOpenChange={setOpen}
        arrow={false}
      >
        <CashierActionButton
          type={ActionType.E_PAYS}
          onClick={() => setOpen(!open)}
        />
      </Popover>
      <ModalQRPayment
        ref={QRPaymentRef}
        onPayment={onPayment}
        onCancel={onCancelPayment}
      />
      <ModalCheckPayment
        ref={checkPaymentRef}
        onPayment={onPayment}
        cashIncentive={cashIncentive}
        cashIncentiveAmount={cashIncentiveAmount}
        enable={enable}
      />
      {completedTicketModalContext}
    </>
  );
};

export default CashierEPays;

const BoxContent = styled(Box)`
  button {
    display: flex;
    padding: 20px 16px;
    .content_content_3_16_semibold {
      flex: 1;
      align-self: stretch;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    &:hover,
    &:active {
      opacity: 0.8;
      transform: scale(1.05);
      transition: all 0.1s;
    }
  }
`;